export const REDIRECT_SOURCE = 'cebia_dc';
export const REDIRECT_KEY = 'utm_source';
